export const GRIDAPI_BASEURI = 'https://grids.meteotest.ch';
